import getStore from '../store/store';
import { getGuid } from 'owa-guid';
import {
    initializePanelTelemetryData,
    popView,
    pushNewView,
    updateCurrentView,
    updatePanelView,
    updateSelectedCalendarEvent,
} from '../actions/timePanelStoreActions';
import { mutator } from 'satcheljs';
import { now } from 'owa-datetime';
import { pop, push, updateTop } from 'owa-navigation-stack';

mutator(initializePanelTelemetryData, () => {
    getStore().sessionId = getGuid();
    getStore().panelOpenTimestamp = now();
});

mutator(updateSelectedCalendarEvent, actionMessage => {
    const { selectedCalendarEventId } = actionMessage;
    getStore().selectedCalendarItemId = selectedCalendarEventId;
});

mutator(pushNewView, actionMessage => {
    const { calendarViewStack } = getStore();
    push(actionMessage.newView, calendarViewStack.stack);
});

mutator(updateCurrentView, actionMessage => {
    const { calendarViewStack } = getStore();
    updateTop(actionMessage.updatedView, calendarViewStack.stack);
});

mutator(updatePanelView, actionMessage => {
    getStore().panelViewType = actionMessage.updatedView;
});

mutator(popView, () => {
    const { calendarViewStack } = getStore();
    pop(calendarViewStack.stack);
});
